import {Routes} from '@angular/router';
import {
  CustomerDetailResolver,
  DetailedEnvironmentResolver,
} from '@epg-apps/utils';
import {userProfileResolveGuard} from '@epg-apps/cdh-guards';

export const customerRoutes: Routes = [
  {
    path: 'customers',
    loadComponent: () =>
      import('@epg-apps/customer-overview').then(
        (m) => m.CdhCustomerOverviewComponent,
      ),
    pathMatch: 'full',
    canActivate: [userProfileResolveGuard],
  },
  {
    path: 'customers/:customerId',
    loadComponent: () =>
      import('@epg-apps/cdh-customer-detail').then(
        (m) => m.CdhCustomerDetailComponent,
      ),
    pathMatch: 'full',
    data: {navigateToPreviousPage: true},
    resolve: {
      data: CustomerDetailResolver,
    },
    canActivate: [userProfileResolveGuard],
  },
  {
    path: 'customers/:customerId/environments/:environmentId',
    loadComponent: () =>
      import('@epg-apps/cdh-environment-detail').then(
        (m) => m.CdhEnvironmentDetailComponent,
      ),
    data: {navigateToPreviousPage: true},
    resolve: {
      data: DetailedEnvironmentResolver,
    },
    canActivate: [userProfileResolveGuard],
  },
  {path: '', redirectTo: 'customers', pathMatch: 'full'},
];
